/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import notification_delete_btn from '../../assets/img/delete_btn.png'
import Empty_star from '../../assets/img/star-icon.png'
import { PreviewImg, PropertyCardImg } from '../../helper/imagepath'
import DeletePopup from '../../component/deletePopup'
import Pagination from '../../component/common/pagination'
import CleaningScheduleDetail from '../../component/Property/Schedule/cleaningScheduleModel'
import { SpinnerContext } from '../../context/spinnerContext'
import { deleteNotification, getNotification, readAllNotification } from '../../redux/slices/notificationSlice'
import { appendImageURL, convertTimestampToDate, convertTimestampToDateWithoutUTC, convertTimestampToTimeWithoutUTC } from '../../helper/function'
import NoDataFound from '../../component/noDataFound'
import { NoFoundText } from '../../util/constant'

const Notifications = () => {
  // Hooks
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { changeLoader } = useContext(SpinnerContext)
  const { allNotification } = useSelector(({ notification }) => notification)
  const { user } = useSelector(({ auth }) => auth)
  // State Management
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(6)
  const [notificationID, setNotificationID] = useState(null)
  const [isRefresh, setIsRefresh] = useState(true)
  const [scheduleID, setScheduleID] = useState(null)
  const [schedulePropertyData, setSchedulePropertyData] = useState(null)
  const [showMoreDetailModal, setShowMoreDetailModal] = useState(false)
  const [isCanceledBookingStatus, setIsCanceledBookingStatus] = useState(false)

  // Modal Toggles
  const toggleMoreDetailModal = () => setShowMoreDetailModal((prev) => !prev)
  const toggleDeleteModal = () => setIsDeleteModalOpen((prev) => !prev)

  // Notification Handling
  const handleNotificationClick = (e, notification) => {
    e.preventDefault()
    setIsCanceledBookingStatus(false)

    const { operation, propertySchedule, cleanings, schedule_cleaners } = notification

    // case 1: Handle operations related to new or assigned cleaning schedules
    if (
      [
        'New property cleaning schedule created',
        'Cleaner assigned to property cleaning request',
        'Property cleaning schedule canceled',
        'Property cleaning schedule canceled by the cleaner',
        'Cancellation charge request accepted',
        'Cancellation charge request declined'
      ]?.includes(operation)
    ) {
      setScheduleID(propertySchedule?.property_schedule_id)
      setSchedulePropertyData(propertySchedule?.propertySchedule_properties)

      if (propertySchedule?.booking_status === 'scheduled') toggleMoreDetailModal()
      if (['canceled', 'in progress', 'completed', 'canceled cleaner'].includes(propertySchedule?.booking_status)) {
        setIsCanceledBookingStatus(true)
        toggleMoreDetailModal()
      }
    }

    // case 2: Handle "Cleaning request accepted/declined" operation
    if (['Cleaning request accepted', 'Cleaning request declined']?.includes(operation)) {
      setScheduleID(schedule_cleaners?.schedule_cleaners_propertySchedule?.property_schedule_id)
      setSchedulePropertyData(schedule_cleaners?.schedule_cleaners_properties)

      if (schedule_cleaners?.schedule_cleaners_propertySchedule?.booking_status === 'scheduled') toggleMoreDetailModal()
      if (
        ['canceled', 'in progress', 'completed', 'canceled cleaner'].includes(schedule_cleaners?.schedule_cleaners_propertySchedule?.booking_status)
      ) {
        setIsCanceledBookingStatus(true)
        toggleMoreDetailModal()
      }
    }

    // case 3: Handle "Cleaning is start" operation
    if (['Cleaning is start']?.includes(operation)) {
      setScheduleID(cleanings?.property_schedule?.property_schedule_id)
      setSchedulePropertyData(cleanings?.property_schedule?.cleanings_properties)

      if (cleanings?.property_schedule?.booking_status === 'scheduled') toggleMoreDetailModal()
      if (['canceled', 'in progress', 'completed'].includes(cleanings?.property_schedule?.booking_status)) {
        setIsCanceledBookingStatus(true)
        toggleMoreDetailModal()
      }
    }
  }

  const handleDelete = (id) => {
    setNotificationID(id)
    toggleDeleteModal()
  }

  const confirmDelete = () => {
    if (!notificationID) return

    changeLoader(true)
    dispatch(deleteNotification(notificationID))
      .then((response) => {
        if (response?.payload?.status === 200) {
          setIsRefresh(true)
          if (allNotification?.notifications?.length === 1) setCurrentPage((prev) => prev - 1)
        }
      })
      .finally(() => {
        changeLoader(false)
        setIsDeleteModalOpen(false)
      })
  }

  // Pagination Handling
  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected + 1)
    setIsRefresh(true)
  }

  // Fetch Notifications
  useEffect(() => {
    if (!isRefresh) return

    const params = { page: currentPage, limit: itemsPerPage, isPagination: true }
    changeLoader(true)
    dispatch(getNotification(params)).finally(() => {
      changeLoader(false)
      setIsRefresh(false)
    })
  }, [currentPage, itemsPerPage, isRefresh])

  useEffect(() => {
    dispatch(readAllNotification())
  }, [])

  return (
    <div className="page-wrapper">
      <>
        <div className="heading_header_div">
          <div>
            <h4>Notification</h4>
          </div>
        </div>
        {allNotification?.notifications?.length > 0 ? (
          allNotification?.notifications?.map((notification) => (
            <>
              {[
                'Cleaning is complete',
                'Property cleaning schedule canceled by the cleaner',
                'Cancellation charge request accepted',
                'Cancellation charge request declined',
                'New cleaning report created'
              ]?.includes(notification?.operation) ? (
                <div className="notification_dataset mb-3" key={notification?.notification_id}>
                  <div className="notification_card_dataset">
                    <div className="notification_img_card">
                      <img
                        className="review_img"
                        src={
                          notification?.cleanings?.images?.[0]
                            ? typeof notification.cleanings.images[0] === 'string'
                              ? appendImageURL(JSON.parse(notification.cleanings.images[0])?.s3Url)
                              : appendImageURL(notification.cleanings.images[0]?.s3Url)
                            : notification?.propertySchedule?.propertySchedule_cleanings?.images?.[0]
                              ? appendImageURL(JSON.parse(notification.propertySchedule.propertySchedule_cleanings.images[0])?.s3Url)
                              : PropertyCardImg
                        }
                        alt="review_img"
                      />
                    </div>
                    <div className="notification_card_text">
                      <h2 className="notification_card_user_name">{notification?.subject}</h2>
                      <h2
                        className="notification_card_user_info"
                        onClick={() => {
                          notification?.cleanings?.property_schedule?.booking_status !== 'completed' &&
                            navigate(
                              `/cleaning-details/${
                                notification?.propertySchedule?.property_schedule_id ||
                                notification?.cleanings?.property_schedule?.property_schedule_id ||
                                notification?.cleaning_reports?.cleaning_reports_cleanings?.cleaning_reports_cleanings_property_schedule
                                  ?.property_schedule_id
                              }`
                            )
                        }}
                      >
                        {notification?.body}
                      </h2>
                    </div>
                  </div>

                  <div className="notification_review_sec_data">
                    <div className="notification_dataset_info">
                      <p className="notification_review_date">
                        {convertTimestampToTimeWithoutUTC(notification?.created_at)}, {convertTimestampToDateWithoutUTC(notification?.created_at)}{' '}
                      </p>
                      {!user?.is_freezed_client && (
                        <button className="notification_card_delete_btn">
                          <img className="notification_delete" src={notification_delete_btn} alt="notification_delete" />
                        </button>
                      )}
                    </div>

                    {notification?.cleanings?.property_schedule?.booking_status === 'completed' && (
                      <button
                        className="need_review_review_btn"
                        onClick={() => navigate(`/cleaning-details/${notification?.cleanings?.property_schedule?.property_schedule_id}`)}
                      >
                        <p className="view_chat_text"> Review </p> <img className="Empty_star" src={Empty_star} alt="Empty_star" />
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <div className="notification_card_sec" key={notification?.notification_id}>
                  <div
                    className="notification_card_personal_info"
                    onClick={(e) => {
                      handleNotificationClick(e, notification)
                    }}
                  >
                    <div className="notification_user_icon">
                      <img className="notification_user_img" src={PreviewImg} alt="notification_user" />
                    </div>
                    <div className="notification_card_text">
                      <h2 className="notification_card_user_name">{notification?.subject}</h2>
                      <h2 className="notification_card_user_info">{notification?.body}</h2>
                    </div>
                  </div>
                  <div className="notification_card_timimng_info">
                    <h6>
                      {convertTimestampToTimeWithoutUTC(notification?.created_at)}, {convertTimestampToDateWithoutUTC(notification?.created_at)}
                    </h6>
                    {!user?.is_freezed_client && (
                      <button
                        className="notification_card_delete_btn"
                        onClick={(e) => {
                          e.stopPropagation()
                          handleDelete(notification?.notification_id)
                        }}
                      >
                        <img className="notification_delete" src={notification_delete_btn} alt="notification_delete" />
                      </button>
                    )}
                  </div>
                </div>
              )}
            </>
          ))
        ) : (
          <NoDataFound title={NoFoundText.NOTIFICATIONS} />
        )}

        {allNotification?.totalRecords > 0 && (
          <div className="row">
            <div className="col-12 pagination_main_div mt-5">
              <Pagination
                currentPage={currentPage}
                onPageChange={handlePageChange}
                totalPages={allNotification?.totalPage || 0}
                itemsPerPage={itemsPerPage}
              />
            </div>
          </div>
        )}
      </>
      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={toggleDeleteModal}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={toggleDeleteModal}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger common-field-btn w-100" onClick={confirmDelete}>
              Delete
            </button>
          </div>
        </DeletePopup>
      )}

      {showMoreDetailModal && (
        <Modal className="scheduledetail_modal_main_div" size="md" centered isOpen={showMoreDetailModal} toggle={toggleMoreDetailModal}>
          <ModalHeader toggle={toggleMoreDetailModal}>{schedulePropertyData?.property_name}</ModalHeader>
          <ModalBody>
            <CleaningScheduleDetail
              scheduleID={scheduleID}
              setIsRefresh={setIsRefresh}
              toggleMoreDetailModal={toggleMoreDetailModal}
              isCanceledBookingStatus={isCanceledBookingStatus}
            />
          </ModalBody>
        </Modal>
      )}
    </div>
  )
}

export default Notifications
